module.exports = __webpack_public_path__ + "img/dice-six.3aa9af27.svg";